var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadPiBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_21129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 20.4H7.91789C6.39895 20.4 5.15994 19.161 5.15994 17.642V6.35801C5.15994 4.83898 6.39895 3.60001 7.91789 3.60001H13.2029C14.0027 3.60001 14.7806 3.89105 15.4149 4.51L17.949 7.04399C18.5667 7.67769 18.8518 8.44964 18.8518 9.24897V17.642C18.8518 19.161 17.613 20.4 16.0938 20.4ZM12.706 14.8771V11.7903C12.706 11.4037 12.3929 11.0903 12.006 11.0903C11.619 11.0903 11.306 11.4037 11.306 11.7903V14.8771L10.4699 14.041C10.1965 13.7676 9.75352 13.7676 9.48008 14.041C9.20664 14.3141 9.20664 14.7575 9.48008 15.0309L11.5104 17.0616C11.7865 17.3379 12.2312 17.3327 12.5014 17.0616L14.5318 15.0309C14.8053 14.7575 14.8053 14.3141 14.5318 14.041C14.2584 13.7676 13.8154 13.7676 13.542 14.041L12.706 14.8771ZM16.9659 8.01363L14.4378 5.48544C14.0882 5.14591 13.6863 4.94271 13.3854 4.87585V8.01363C13.3854 8.56546 13.8282 9.00822 14.3866 9.00822H17.5564C17.5105 8.77937 17.3118 8.36996 16.9659 8.01363Z",
    fill: "#0067E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_21129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPiBlue);
export default __webpack_public_path__ + "static/media/Download_PI_Blue.14aff81ba15e787a20567a449e471a93.svg";
export { ForwardRef as ReactComponent };